import "./onevacancycard.scss";
import { inject, observer } from "mobx-react";

const OneVacancyCard = ({
  position,
  salary,
  worklocation,
  id,
  selectedVacancy
}) => {
  return (
    <div
      className={`card-vacancy-candidate ${
        selectedVacancy == id ? "card-vacancy-bluecandidate" : ""
      }`}
    >
      <div className="card-vacancy-candidate__cols">
        <p className="card-vacancy-candidate__text-position">
          {position.split(/ (\d)/)[0]}
        </p>
        <p className="card-vacancy-candidate__text-city">{salary} руб</p>
      </div>

      <div className="card-vacancy-candidate__cols">
        <p className="card-vacancy-candidate__text-city">
          {worklocation.length > 0 ? <>г. {worklocation}</> : ""}
        </p>
        {/* Вознаграждение скрыто в задаче FRONT-843 */}
        {/* <div className="card-vacancy-candidate__cols">
                    <p className="card-vacancy-candidate__text-small">
                        Ваше вознаграждение:
                    </p>
                    <div className="card-vacancy-candidate__imgcols">
                        <p className="card-vacancy-candidate__text-city">
                            {agentSalary} руб
                        </p>

                        {selectedVacancy == id ? (
                            <img
                                src={ok}
                                className="card-vacancy-candidate__ok"
                                alt=""
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div> */}
      </div>
    </div>
  );
};

export default inject(({ candidatesStore }) => {
  const { selectedVacancy } = candidatesStore;
  return {
    selectedVacancy
  };
})(observer(OneVacancyCard));
